import { render, staticRenderFns } from "./EditDepartmentsModal.vue?vue&type=template&id=d1ace3da&scoped=true&"
import script from "./EditDepartmentsModal.vue?vue&type=script&lang=js&"
export * from "./EditDepartmentsModal.vue?vue&type=script&lang=js&"
import style0 from "./EditDepartmentsModal.vue?vue&type=style&index=0&id=d1ace3da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ace3da",
  null
  
)

export default component.exports